<template lang="html">
    <div class="page-container">
        <div class="page-container__header">
            <h1 class="header-1 page-container__title" style="margin: auto;">Setări</h1>
        </div>
        <div class="page-container__body">
            <CardPassword />
            <CardProfile />
            <CardBillingInfo v-if="user.id !== ''" />
        </div>
    </div>
</template>

<script>

import UiInput from "@/components/ui/Input"
import UiButton from "@/components/ui/Button"
import CardPassword from '@/pages/client/SettingsPage/components/CardPassword'
import CardProfile from '@/pages/client/SettingsPage/components/CardProfile'
import CardBillingInfo from '@/pages/client/SettingsPage/components/CardBillingInfo'

import { mapGetters } from 'vuex'

export default {
    components: {
        UiInput,
        UiButton,
        CardPassword,
        CardProfile,
        CardBillingInfo
    },
    computed: {
        ...mapGetters({
            user: 'user/user'
        }),
    }
}
</script>

<style lang="scss">
    @import "@/scss/pages/client-settings";

    .error {
        color: $color-danger;
        text-align: center;
    }
</style>
